{
  "blocks": [
    {
      "id": "program-embryo-freezing",
      "kind": "program",
      "tags": [
        "embryo-freezing",
        "both-partners",
        "treatment",
        "pre-cycle",
        "during-cycle"
      ],
      "title": "Embryo Freezing",
      "subtitle": "Create and freeze embryos: assessment through genetic testing",
      "icon": "🧊",
      "body": {
        "duration": "3 weeks – 5 months",
        "includes": [
          "Full fertility assessment for both partners",
          "Optional 90-day optimization for her and him",
          "Ovarian stimulation with monitoring",
          "Egg retrieval procedure",
          "Fertilization and embryo culture to blastocyst",
          "Optional PGT-A genetic screening of embryos",
          "Cryopreservation and annual storage"
        ],
        "priceRange": {
          "low": 15000,
          "high": 25000
        },
        "currency": "USD",
        "status": "coming-soon",
        "forWhom": "both",
        "category": "treatment",
        "customizable": true,
        "moduleIds": [
          "module-female-hormone-baseline",
          "module-male-fertility-baseline",
          "module-female-optimization",
          "module-male-optimization",
          "module-ovarian-stimulation",
          "module-egg-retrieval",
          "module-fertilization-culture",
          "module-pgt-a"
        ],
        "optionalModuleIds": [
          "module-female-optimization",
          "module-male-optimization",
          "module-pgt-a"
        ],
        "phases": [
          {
            "title": "Assessment",
            "description": "Understand where you both stand",
            "moduleIds": [
              "module-female-hormone-baseline",
              "module-male-fertility-baseline"
            ],
            "parallel": true
          },
          {
            "title": "Optimize (optional)",
            "description": "90 days to prepare both partners",
            "moduleIds": [
              "module-female-optimization",
              "module-male-optimization"
            ],
            "parallel": true
          },
          {
            "title": "Stimulation & Retrieval",
            "description": "Stimulation, retrieval, and sperm collection",
            "moduleIds": ["module-ovarian-stimulation", "module-egg-retrieval"]
          },
          {
            "title": "Fertilization & Testing",
            "description": "Embryo development and optional genetic screening",
            "moduleIds": ["module-fertilization-culture", "module-pgt-a"]
          }
        ],
        "steps": [
          {
            "title": "Both assessed",
            "description": "Hormone panel + ultrasound for her, semen analysis for him."
          },
          {
            "title": "Optimize (optional)",
            "description": "90 days of supplements and lifestyle changes for both partners."
          },
          {
            "title": "Stimulation & Retrieval",
            "description": "10–14 days of stimulation, then egg retrieval and sperm collection."
          },
          {
            "title": "Fertilization & Testing",
            "description": "Fertilization, culture to blastocyst, optional PGT-A screening, then freeze."
          }
        ]
      },
      "sources": [
        {
          "title": "Planned oocyte cryopreservation outcomes and predictors",
          "journal": "Fertility and Sterility",
          "year": 2023,
          "evidenceLevel": "cohort"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "program-embryo-freezing",
      "to": "module-female-hormone-baseline",
      "type": "contains"
    },
    {
      "from": "program-embryo-freezing",
      "to": "module-male-fertility-baseline",
      "type": "contains"
    },
    {
      "from": "program-embryo-freezing",
      "to": "module-female-optimization",
      "type": "contains"
    },
    {
      "from": "program-embryo-freezing",
      "to": "module-male-optimization",
      "type": "contains"
    },
    {
      "from": "program-embryo-freezing",
      "to": "module-ovarian-stimulation",
      "type": "contains"
    },
    {
      "from": "program-embryo-freezing",
      "to": "module-egg-retrieval",
      "type": "contains"
    },
    {
      "from": "program-embryo-freezing",
      "to": "module-fertilization-culture",
      "type": "contains"
    },
    {
      "from": "program-embryo-freezing",
      "to": "module-pgt-a",
      "type": "contains"
    }
  ],
  "localeVariants": []
}
